export default __webpack_public_path__ + "static/media/mature-fund-active.e673dd2d.svg";